export class Header {
	constructor() {
		this.init();
	}

	init() {
		this.initUserMenu();
		this.initBodyScrollClass();
		this.initTransparentScroll();
	}

	initUserMenu() {
		const menus = document.querySelectorAll('.header__user');

		if (!menus.length) {
			return;
		}

		const closeAll = (except = null) => {
			menus.forEach((menu) => {
				if (menu !== except) {
					menu.classList.remove('open');
				}
			});
		};

		menus.forEach((menu) => {
			const icon = menu.querySelector('.header__user--icon');

			// Hover opens the menu via CSS; the click toggle covers touch devices.
			if (icon) {
				icon.addEventListener('click', (event) => {
					event.stopPropagation();
					closeAll(menu);
					menu.classList.toggle('open');
				});
			}
		});

		document.addEventListener('click', (event) => {
			menus.forEach((menu) => {
				if (!menu.contains(event.target)) {
					menu.classList.remove('open');
				}
			});
		});

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				closeAll();
			}
		});
	}

	initBodyScrollClass() {
		const update = () => {
			document.body.classList.toggle('is-scrolled', window.scrollY > 0);
		};

		update();
		window.addEventListener('scroll', update, { passive: true });
	}

	initTransparentScroll() {
		const header = document.querySelector('header.header-transparent');
		const hero = document.querySelector('.home__hero');

		if (!header) {
			return;
		}

		const updateHeader = () => {
			const pastHero = hero
				? hero.getBoundingClientRect().bottom <= 0
				: window.scrollY > 0;

			header.classList.toggle('header-scrolled', pastHero);
		};

		updateHeader();
		window.addEventListener('scroll', updateHeader, { passive: true });
		window.addEventListener('resize', updateHeader, { passive: true });
	}
}
